import { Component } from '@angular/core';
import { NotificationService } from '../../services/notification.service';

@Component({
  standalone: false,
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent {
  constructor(public notificationService: NotificationService) {}
}
